// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__6UCU8","list":"BalanceDue_list__3jQWx","listRow":"BalanceDue_listRow__1U2dW","total":"BalanceDue_total__15vTQ"};